var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiconDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2457 2.80078H2.80122C1.81938 2.80078 1.02344 3.59672 1.02344 4.57856V17.023C1.02344 18.0048 1.81938 18.8008 2.80122 18.8008H15.2457C16.2275 18.8008 17.0234 18.0048 17.0234 17.023V4.57856C17.0234 3.59672 16.2275 2.80078 15.2457 2.80078Z",
    stroke: "#178477",
    strokeWidth: 2.04709,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5789 1.02344V4.57899",
    stroke: "#178477",
    strokeWidth: 2.04709,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46802 1.02344V4.57899",
    stroke: "#178477",
    strokeWidth: 2.04709,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02344 8.13477H17.0234",
    stroke: "#178477",
    strokeWidth: 2.04709,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiconDate);
export default __webpack_public_path__ + "static/media/micon-date.363d52aec2c0ddb50515ece31f7cc1ee.svg";
export { ForwardRef as ReactComponent };